<template>
  <div class="vue-mobile-footer-wrap">
    <div class="columns-container">
      <div
      class="column icon-container"
      v-on:click="toggleDesktopList()">
        <div class="column-row icon-row list">
            <img v-if="!desktopListVisible" class="icon list" src="../../../assets/img/icon-mobile-list.svg" alt="list-icon">
            <img v-if="desktopListVisible" class="icon list" src="../../../assets/img/icon-mobile-list-map.svg" alt="list-icon">
        </div>
        <div v-if="!desktopListVisible" class="column-row text-row"><span class="text">List</span></div>
        <div v-if="desktopListVisible" class="column-row text-row"><span class="text">Map</span></div>
      </div>
      <div
      class="column icon-container"
      v-on:click="showDataModal()">
        <div class="column-row icon-row chart">
            <img class="icon" src="../../../assets/img/drawer-icon-chart.svg" alt="chart-icon">
        </div>
        <div class="column-row text-row"><span class="text">Data</span></div>
      </div>
      <div class="column icon-container help">
        <div
        class="column-row icon-row"
        v-on:click="showHelpModal()">
          <img class="icon" src="../../../assets/img/drawer-icon-help.svg" alt="help-icon">
        </div>
        <div class="column-row text-row"><span class="text">Help</span></div>
      </div>
      <span class="column icon-container">
        <div class="column-row icon-row">
          <img
          v-if="!isDarkMode"
          v-on:click="onDarkModeChangeEventHandler()"
          class="icon" src="../../../assets/img/drawer-icon-dark-mode.svg" alt="dark-mode-icon">
          <img
          v-if="isDarkMode"
          v-on:click="onDarkModeChangeEventHandler()"
          class="icon" src="../../../assets/img/drawer-icon-light-mode.svg" alt="dark-mode-icon">
        </div>
        <div class="column-row text-row">
          <span v-if="!isDarkMode"><span class="text">Dark</span></span>
          <span v-if="isDarkMode"><span class="text">Light</span></span>
        </div>
      </span>
      <span class="column icon-container login">
        <div class="column-row icon-row">
          <img
          v-if="!user"
          class="icon"
          v-on:click="showLoginModal()"
          src="../../../assets/img/drawer-icon-login.svg" alt="login-icon">
          <user-avatar
          v-if="user"
          :user="user"
          :userIsAdmin="userIsAdmin"
          :userAvatarClicked="onUserAvatarClicked"></user-avatar>
        </div>
        <div class="column-row text-row">
          <span v-if="!user" class="text">Login</span>
          <span v-if="user" class="text">User</span>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import UserAvatar from "@/components/shared/user/UserAvatar";

export default {
  name: 'MobileFooter',
  components: {
    UserAvatar,
  },
  methods: {
    onDarkModeChangeEventHandler () {this.toggleDarkMode()}
  },
  props: {
    user: Object,
    isDarkMode: Boolean,
    userIsAdmin: Boolean,
    desktopListVisible: Boolean,
    showHelpModal: Function,
    showLoginModal: Function,
    toggleDarkMode: Function,
    onUserAvatarClicked: Function,
    toggleDesktopList: Function,
    showDataModal: Function
  },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.vue-mobile-footer-wrap{
  height: 70px;
  background-color: $navyBackgroundTrans95;

  .columns-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;

    .column{
      &.icon-container{
        position: relative;
        width: 25px;
        height: 45px;
        margin: 0 auto;

        .column-row{
          &.icon-row{
            position: relative;

            &.chart{
              .icon{
                top: 2px;
                position: relative;
              }
            }

            .icon{
              width: 25px;
            }
          }

          &.text-row{
            position: absolute;
            bottom: 0;

            a{
              color: #fff;
            }

            .text{
              display: block;
              width: 25px;
              text-align: center;
              font-size: 10px;
              color: $greyTextTrans65;
            }
          }
        }
      }
    }
  }
}
</style>
